const cleanObject = (obj, key) => {
  if (!obj[key]) {
    delete obj[key];
  }
  return obj;
};

export default cleanObject;
